import { ThemeOptions } from "@mui/material";

export const initialStyle:ThemeOptions = {
  typography: {
    fontFamily: "Poppins,sans-serif",
  },
  palette:{
     mode:"light",
     sideBarColor:{
        main:"#2c2e3e",
        dark:"#282a3c",
        light:"#f8f9fa",
        contrastText:"#868aa8",
        A100:"#716aca"
     },
     background:{
      default:"#f2f3f8"
     }
  },
  components: {
    MuiTextField: {
      defaultProps: { variant: "outlined", fullWidth: true, size: "small" },
    },
    MuiButton: {
      defaultProps: { variant: "contained", size: "small" },
    },
    MuiCheckbox: {
      defaultProps: { size: "small" },
    },
    MuiAutocomplete: {
      defaultProps: { autoHighlight: true },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 2,
      },
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
        rounded: {
          borderRadius: `5px`,
        },
      },
    },
  },
}